import React, { ReactElement, ReactNode } from 'react';
import { Typography } from '../Typography/Typography';
import styles from './PageHeading.module.scss';
import { ArrowBack } from '../../assets/icons/ArrowBack';
import { IOption } from '../Dropdown/Dropdown';
import EllipsisMenu from '../EllipsisMenu/EllipsisMenu';
import { VerticalDivider } from '../../assets/icons/VerticalDivider';
import { Plus } from '../../assets/icons/Plus';
import IconButton from '../IconButton/IconButton';

export interface IPageHeadingProps {
  children?: ReactNode;
  title: string;
  onPlusClick?: () => void;
  onBackClick?: () => void;
  ellipsisMenuItems?: IOption[];
  Icon?: (props: Record<string, unknown>) => ReactElement;
  showDivider?: boolean;
}

export const PageHeading = ({
  title,
  children,
  onPlusClick = undefined,
  onBackClick = undefined,
  ellipsisMenuItems = [],
  Icon = undefined,
  showDivider = false,
}: IPageHeadingProps) => {
  return (
    <div className={styles['page-heading']}>
      <div className={styles['left-content']}>
        {onBackClick && (
          <IconButton aria-label="Back Button" onClick={onBackClick}>
            <ArrowBack className={styles['arrow']} />
          </IconButton>
        )}
        {Icon && <Icon size="large" className={styles['icon']} />}
        <Typography size="XXL" weight="semi-bold">
          {title}
        </Typography>
        {onPlusClick && (
          <IconButton aria-label="Plus Button" onClick={onPlusClick}>
            <Plus />
          </IconButton>
        )}
      </div>
      <div className={styles['right-content']}>
        {children}
        {showDivider && <VerticalDivider className={styles['divider']} />}
        {ellipsisMenuItems.length > 0 && (
          <EllipsisMenu options={ellipsisMenuItems} colour="blueberry" variant="outline" />
        )}
      </div>
    </div>
  );
};
